import { render, staticRenderFns } from "./FreeCanvasSimpleWorkspace.vue?vue&type=template&id=66aa4ef4&scoped=true"
import script from "./FreeCanvasSimpleWorkspace.vue?vue&type=script&lang=js"
export * from "./FreeCanvasSimpleWorkspace.vue?vue&type=script&lang=js"
import style0 from "./FreeCanvasSimpleWorkspace.vue?vue&type=style&index=0&id=66aa4ef4&prod&scoped=true&lang=css"
import style1 from "./FreeCanvasSimpleWorkspace.vue?vue&type=style&index=1&id=66aa4ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa4ef4",
  null
  
)

export default component.exports